import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import * as Types from './operations';
const defaultOptions = {} as const;

export const MuseumOgpArtworkDocument = gql`
  query MuseumOgpArtwork(
    $artworkId: ItemId
    $museumSlug: String!
    $locale: SiteLocale
  ) {
    museumExhibition(filter: { slug: { eq: $museumSlug } }, locale: $locale) {
      id
      slug
      title
      ogpArtworkImagePublic
      thumbnailImage(locale: $locale) {
        id
        width
        height
        url(
          imgixParams: {
            auto: compress
            fit: fillmax
            fill: blur
            h: "630"
            w: "1200"
          }
        )
      }
      booths {
        id
        needTicket
        artworks {
          id
        }
      }
    }
    museumArtwork(locale: $locale, filter: { id: { eq: $artworkId } }) {
      id
      image {
        url(
          imgixParams: {
            auto: compress
            fit: fillmax
            fill: blur
            h: "630"
            w: "1200"
          }
        )
      }
    }
  }
`;

/**
 * __useMuseumOgpArtworkQuery__
 *
 * To run a query within a React component, call `useMuseumOgpArtworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useMuseumOgpArtworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMuseumOgpArtworkQuery({
 *   variables: {
 *      artworkId: // value for 'artworkId'
 *      museumSlug: // value for 'museumSlug'
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useMuseumOgpArtworkQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.MuseumOgpArtworkQuery,
    Types.MuseumOgpArtworkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.MuseumOgpArtworkQuery,
    Types.MuseumOgpArtworkQueryVariables
  >(MuseumOgpArtworkDocument, options);
}
export function useMuseumOgpArtworkLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.MuseumOgpArtworkQuery,
    Types.MuseumOgpArtworkQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.MuseumOgpArtworkQuery,
    Types.MuseumOgpArtworkQueryVariables
  >(MuseumOgpArtworkDocument, options);
}
export type MuseumOgpArtworkQueryHookResult = ReturnType<
  typeof useMuseumOgpArtworkQuery
>;
export type MuseumOgpArtworkLazyQueryHookResult = ReturnType<
  typeof useMuseumOgpArtworkLazyQuery
>;
export type MuseumOgpArtworkQueryResult = Apollo.QueryResult<
  Types.MuseumOgpArtworkQuery,
  Types.MuseumOgpArtworkQueryVariables
>;
export const MuseumContentDocument = gql`
  query MuseumContent(
    $slug: String!
    $locale: SiteLocale
    $isOpen: BooleanType
  ) {
    museumExhibition(
      filter: { slug: { eq: $slug }, isOpen: { eq: $isOpen } }
      locale: $locale
    ) {
      id
      slug
      title
      shopText
      shopUrl
      shareText
      lpUrl
      twitterHashTag
      announcement
      movieBalloonIcon {
        url(imgixParams: { auto: compress, fit: max, h: "128", w: "128" })
      }
      thumbnailImage {
        url(imgixParams: { auto: compress, fit: max, h: "640", w: "640" })
      }
      tutorialContents {
        id
        image {
          url(imgixParams: { auto: compress, fit: max, h: "640", w: "640" })
          mimeType
          width
          height
        }
        voice {
          id
          url
        }
        text
      }
      commentDoneArtworks {
        url
      }
      boothGroups {
        id
        name
        thumbnailImage {
          id
          url(imgixParams: { auto: compress, fit: max, h: "1440", w: "600" })
          mimeType
          width
          height
        }
        booths {
          id
          name
          subtitle
          title
          needTicket
          thumbnailImage {
            id
            url(imgixParams: { auto: compress, fit: max, h: "250", w: "500" })
            mimeType
            width
            height
          }
        }
      }
      booths {
        id
        name
        title
        subtitle
        isOpen
        endGuidanceText
        endGuidanceImage {
          url(imgixParams: { auto: compress, fit: max, h: "500", w: "1650" })
        }
        endGuidanceButtons {
          label
          url
          booth {
            id
            name
            title
          }
        }
        thumbnailImage {
          id
          url(imgixParams: { auto: compress, fit: max, h: "250", w: "500" })
          mimeType
          width
          height
        }
        introductionImage(locale: $locale) {
          url(imgixParams: { auto: compress, fit: max, h: "1000", w: "1000" })
          mimeType
          width
          height
        }
        replaceImages {
          key
          image {
            url(imgixParams: { auto: compress })
            mimeType
            width
            height
          }
        }
        keyImages {
          url(imgixParams: { auto: compress })
          mimeType
          width
          height
        }
        bgm {
          id
          url
        }
        artworks {
          id
          name
          isOpen
          isNameBold
          description(locale: $locale)
          shopifyProduct
          shopifyCollectionId
          image(locale: $locale) {
            url(
              imgixParams: {
                auto: compress
                fm: jpg
                fit: max
                h: "1000"
                w: "1000"
              }
            )
            mimeType
            width
            height
          }
          hdImage(locale: $locale) {
            url(imgixParams: { auto: compress, fm: jpg })
            mimeType
            width
            height
          }
          captionImage {
            url(imgixParams: { auto: compress, fm: jpg })
            mimeType
            width
            height
          }
          frameImage {
            url(imgixParams: { auto: compress, fm: jpg })
            mimeType
            width
            height
          }
          frameImageViewable
          movie(locale: $locale) {
            video {
              streamingUrl
              duration
            }
            mimeType
            width
            height
          }
          thumbnailImage(locale: $locale) {
            url(imgixParams: { auto: compress, fm: jpg })
            width
            height
          }
          mutedMovie
          autoPlay
          canComment
          externalShopUrl
          comments {
            text
            commentator {
              id
              name
              avatar {
                url(imgixParams: { auto: compress, fm: jpg, h: "50", w: "50" })
              }
            }
          }
          museumVoices {
            id
            museumVoiceEdition {
              id
            }
            hlsUrl
            voiceFile {
              id
              mimeType
              url
            }
            commentator {
              id
              name
              avatar {
                url(imgixParams: { auto: compress, fm: jpg, h: "50", w: "50" })
              }
            }
          }
        }
        frameImage {
          url(imgixParams: { auto: compress, fm: jpg })
          mimeType
          width
          height
        }
        frameImageViewable
        freeArtworkCount
        needTicket
        space {
          mainModel {
            url
            customData
          }
          fixedFrameSize
          maxDistanceBetweenArtworksSmoothly
          environment {
            totalBrightness
            originalBrightness
            bloomStrength
            bloomRadius
            bloomThreshold
          }
          shortenModel
        }
      }
      userIcons {
        url(imgixParams: { auto: compress, fm: jpg, h: "80", w: "80" })
      }
      appearance {
        corridorModel {
          url
          customData
        }
        corridorEnvironment {
          totalBrightness
          originalBrightness
          bloomStrength
          bloomRadius
          bloomThreshold
        }
        backgrounds {
          url(imgixParams: { auto: compress, fm: jpg })
          mimeType
          width
          height
        }
      }
    }
  }
`;

/**
 * __useMuseumContentQuery__
 *
 * To run a query within a React component, call `useMuseumContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMuseumContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMuseumContentQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      locale: // value for 'locale'
 *      isOpen: // value for 'isOpen'
 *   },
 * });
 */
export function useMuseumContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.MuseumContentQuery,
    Types.MuseumContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.MuseumContentQuery,
    Types.MuseumContentQueryVariables
  >(MuseumContentDocument, options);
}
export function useMuseumContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.MuseumContentQuery,
    Types.MuseumContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.MuseumContentQuery,
    Types.MuseumContentQueryVariables
  >(MuseumContentDocument, options);
}
export type MuseumContentQueryHookResult = ReturnType<
  typeof useMuseumContentQuery
>;
export type MuseumContentLazyQueryHookResult = ReturnType<
  typeof useMuseumContentLazyQuery
>;
export type MuseumContentQueryResult = Apollo.QueryResult<
  Types.MuseumContentQuery,
  Types.MuseumContentQueryVariables
>;
